<template>
  <div class="a11y-modal">
    <div class="title">
      <h2>Estimated Coverage: <em>{{ numberOfDays }} Days</em></h2>
      <button class="close" @click="closeModal">×</button>
    </div>

    <div class="content">
      <div class="row">
        <div class="col-12 mb-2">
          <h3>How we calculate coverage</h3>
          <p>
            Our coverage estimate finds your average individual credit usage for
            the past 4 weeks. Based on that average we calculate how many days
            are left until credits are depleted (assuming usage remains steady).
          </p>
          <h3>How this can help</h3>
          <p>
            Understanding when credits may be depleted will help you plan ahead
            to ensure your users are always covered with the credits they
            need.
          </p>
        </div>
      </div>
    </div>

    <div class="actions">
      <button type="button" @click="closeModal">Close</button>
    </div>
  </div>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  name: 'CoverageDocumentationModal',

  props: {
    numberOfDays: {
      type: Number,
      required: true
    }
  },

  methods: {
    closeModal() {
      this.$modal.close();
    }
  }
});
</script>

<style lang="scss" scoped>
.title {
  border-bottom: none;
}

.content {
  padding-top: 0;
}

h3 {
  color: #303030;
  font-family: $sans;
  font-size: 16px;
  margin: 20px 0 4px 0;
}
</style>
